<template>
  <div>
    <popup-hint hint="casktypes">
      <template v-slot:breadcrumbs>
        <breadcrumbs :back="[{text:'Casks',to:{name:'InventoryCasks'}}]" home="Cask types"/>
      </template>
      <template v-slot:top>
        Cask types are used to properly display the change in spirit type that occurs during barrel maturation.
      </template>
      <template v-slot:actions="{close}">
        <v-btn @click="close()" :to="{name:'InventoryCasksTypesEditNew'}" color="primary" class="ml-4" small>Create</v-btn>
      </template>
    </popup-hint>

    <purtrak-table name="casktypes" objectType="cask types" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="caskTypes2" :listFilters="[]"
                   fields="spiritInId,spiritInName,spiritOutName,minimumAge,colour"
                   @dblclick="type => $router.push({name:'InventoryCasksTypesEditNew',params:{spiritInId:type.spiritInId}})"
                   title="Cask types"
                   :print-info="{pageSize:'portrait',subTitle:[]}"
                   download-endpoint="caskTypesExportCSV">
      <template v-slot:menu v-if="!readOnly">
        <v-list-item :to="{name:'InventoryCasksTypesEditNew'}"><v-list-item-title>Create new type</v-list-item-title></v-list-item>
      </template>
      <template v-slot:item.minimumAge="{value}">
        <template v-if="value/365 >=1">
          {{Math.trunc(value/365) | number(0)}} year{{Math.trunc(value/365) > 1 ? 's' : ''}}
        </template>
        <template v-if="value%365">
          {{value%365 | number(0)}} day{{value%365 > 1 ? 's' : ''}}
        </template>
      </template>
      <template v-slot:item.colour="{value}">
        <div style="width:100%;height:30px" :style="{backgroundColor:value}"></div>
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'InventoryCasksTypesEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn small icon @click.stop="typeToDelete=item;showDelete=true"><v-icon small>mdi-delete</v-icon></v-btn>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this cask type" @delete="performDeleteType"/>
  </div>
</template>

<script>

export default {
  name: 'InventoryCasksTypes',
  data() {
    return {
      typeToDelete: {},
      showDelete: false,
      defaultColumns: [{ value: 'spiritInName', visible:true},
                       { value: 'spiritOutName', visible:true},
                       { value: 'minimumAge', visible:true},
                       { value: 'colour', visible:true}],
      headers: [{ text: 'STARTING SPIRIT', value: 'spiritInName', width:'30%',sortable:true},
                { text: 'SPIRIT ON MATURATION', value: 'spiritOutName', width:'30%',sortable:true},
                { text: 'MATURE TIME', value: 'minimumAge', width:'20%',sortable:true},
                { text: 'DISPLAY COLOUR', value: 'colour', width:'15%',sortable:false, align:'center',print:false}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('inventory.write');
    }
  },
  methods: {
    async performDeleteType() {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryCasksTypes($spiritInId: ID!) {
                                                caskTypeDelete(spiritInId:$spiritInId) {
                                                  spiritInId
                                                }
                                              }`,
                                          {spiritInId:this.typeToDelete.spiritInId});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table?.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted cask type ${this.typeToDelete.spiritInName}`});
      }
    },
  }
}
</script>